(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["mb-cart-terms-highlight"] && !Shopify.designMode) return;
  try {
    (() => {
    const checkboxSelector = 'input[id="effectiveAppsAgreeCB"]';
    const checkoutSelector = '[name="checkout"], [tac-co-cloned="true"], [name="tac-checkout"], a[href="/checkout"]';

    function highlightMissingConsent() {
      const checkboxes = [...document.querySelectorAll(checkboxSelector)].filter(
        checkbox => !checkbox.checked && checkbox.getClientRects().length > 0 && getComputedStyle(checkbox).visibility !== 'hidden'
      );

      checkboxes.forEach(checkbox => {
        checkbox.parentElement.classList.add('mb-cart-terms-error');
        checkbox.setAttribute('aria-invalid', 'true');
      });

      const firstCheckbox = checkboxes[0];
      if (!firstCheckbox) return;

      requestAnimationFrame(() => {
        if (!firstCheckbox.isConnected || firstCheckbox.checked) return;
        firstCheckbox.focus({ preventScroll: true });
        firstCheckbox.parentElement.scrollIntoView({
          block: 'nearest',
          inline: 'nearest',
          behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'
        });
      });
    }

    document.addEventListener('click', event => {
      if (event.target instanceof Element && event.target.closest(checkoutSelector)) {
        highlightMissingConsent();
      }
    }, true);

    document.addEventListener('submit', event => {
      if (event.target instanceof HTMLFormElement && event.target.querySelector(checkoutSelector)) {
        highlightMissingConsent();
      }
    }, true);

    document.addEventListener('change', event => {
      if (!(event.target instanceof Element) || !event.target.matches(checkboxSelector) || !event.target.checked) return;

      document.querySelectorAll(checkboxSelector).forEach(checkbox => {
        checkbox.parentElement.classList.remove('mb-cart-terms-error');
        checkbox.removeAttribute('aria-invalid');
      });
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
